"use client";

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

type StudentTypeChartProps = {
  data: {
    student_type_name: string;
    shortage: number;
    waitlist_count: number;
  }[];
};

export default function StudentTypeChart({ data }: StudentTypeChartProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">
          Shortage by Student Type
        </h2>
        <p className="text-sm text-slate-500">
          Identify which groups are most affected.
        </p>
      </div>

      <div className="h-96">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 12, right: 12 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis
              type="category"
              dataKey="student_type_name"
              width={120}
            />
            <Tooltip />
            <Bar dataKey="shortage" name="Shortage" radius={[0, 8, 8, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
